export const initialWalmartConnectState = {
  step: "credentials",
  credentials: { clientId: "", clientSecret: "" },
  verifying: false,
  verificationError: null,
  seller: null,
  capabilities: null,
  syncSettings: {
    catalog: true,
    inventory: true,
    pricing: true,
    offers: true,
    seller_metrics: true,
    orders: false,
  },
  connecting: false,
  connectError: null,
};

export function walmartConnectReducer(state, action) {
  switch (action.type) {
    case "RESET":
      return { ...initialWalmartConnectState };
    case "SET_FIELD":
      return {
        ...state,
        credentials: {
          ...state.credentials,
          [action.field]: action.value,
        },
      };
    case "VERIFY_START":
      return { ...state, verifying: true, verificationError: null };
    case "VERIFY_SUCCESS":
      return {
        ...state,
        verifying: false,
        step: "verify",
        seller: action.seller,
        capabilities: action.capabilities,
        syncSettings: buildDefaultSync(action.capabilities),
      };
    case "VERIFY_ERROR":
      return {
        ...state,
        verifying: false,
        verificationError: action.message,
      };
    case "SET_STEP":
      return { ...state, step: action.step };
    case "TOGGLE_SYNC":
      return {
        ...state,
        syncSettings: {
          ...state.syncSettings,
          [action.id]: action.value,
        },
      };
    case "CONNECT_START":
      return { ...state, connecting: true, connectError: null };
    case "CONNECT_SUCCESS":
      return initialWalmartConnectState;
    case "CONNECT_ERROR":
      return { ...state, connecting: false, connectError: action.message };
    default:
      return state;
  }
}

function buildDefaultSync(capabilities) {
  const cap = capabilities || {};
  return {
    catalog: cap.catalog !== false,
    inventory: !!cap.inventory,
    pricing: cap.pricing !== false,
    offers: cap.offers !== false,
    seller_metrics: cap.seller_metrics !== false,
    orders: false,
  };
}

export const SYNC_OPTIONS = [
  { id: "catalog", title: "Product catalog" },
  { id: "inventory", title: "Inventory" },
  { id: "pricing", title: "Pricing" },
  { id: "offers", title: "Marketplace offers" },
  { id: "seller_metrics", title: "Seller metrics" },
  { id: "orders", title: "Orders" },
];
